module.exports = __webpack_public_path__ + "assets/img/openinvest-get-started-w720.ca4d017a.webp";